import { render, staticRenderFns } from "./material-set-list-item.vue?vue&type=template&id=409f76c0&"
import script from "./material-set-list-item.vue?vue&type=script&lang=js&"
export * from "./material-set-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports